import "./header.css";

import React from "react";
import { Link, useLocation } from "react-router-dom";

import { NAV_LINKS, ROUTES, SITE_NAME } from "../../data/content";

//Anchor links (/#about) are "active" when that hash is showing; plain page links when the path matches
const isLinkActive = (to, pathname, hash) => {
  const [path, anchor] = to.split("#");
  if (anchor) {
    return pathname === path && hash === `#${anchor}`;
  }
  return pathname === path && (path !== ROUTES.HOME || !hash);
};

const Header = () => {
  const { pathname, hash } = useLocation();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);

  //Close the menu on navigation
  React.useEffect(() => {
    setMenuOpen(false);
  }, [pathname, hash]);

  //Header gets more solid once the page scrolls, so the menu stays readable over light sections
  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  //Close the mobile menu with Escape
  React.useEffect(() => {
    if (!menuOpen) {
      return undefined;
    }
    const onKey = (e) => {
      if (e.key === "Escape") {
        setMenuOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  return (
    <header className={`site-header${scrolled ? " scrolled" : ""}${menuOpen ? " menu-open" : ""}`}>
      <div className={"header-inner"}>
        <Link
          to={ROUTES.HOME}
          className={"header-logo"}
          aria-label={`${SITE_NAME} home`}
        >
          <img
            src={"/images/logo-colour.png"}
            alt={"Alman’s Dried Fruit & Nuts"}
            width={"129"}
            height={"112"}
          />
        </Link>

        <button
          type={"button"}
          className={"menu-toggle"}
          aria-expanded={menuOpen}
          aria-controls={"site-nav"}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className={"visually-hidden"}>{menuOpen ? "Close menu" : "Open menu"}</span>
          <span
            className={"menu-icon"}
            aria-hidden={"true"}
          />
        </button>

        <nav
          id={"site-nav"}
          className={"site-nav"}
          aria-label={"Main"}
        >
          <ul>
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className={`nav-link${isLinkActive(link.to, pathname, hash) ? " active" : ""}`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
